module.exports = __webpack_public_path__ + "img/medica.e18a5cca.svg";